module.exports = __webpack_public_path__ + "static/media/automation_tasks.0cac1406.webp";